import React from 'react';

const SlidersTab = ({ sliders, onOpenModal, onDeleteSlider, getImageUrl }) => {
    // Sort sliders by order ASC, then by ID
    const sortedSliders = [...sliders].sort((a, b) => {
        const orderA = a.order !== undefined && a.order !== null ? a.order : 999;
        const orderB = b.order !== undefined && b.order !== null ? b.order : 999;
        if (orderA !== orderB) return orderA - orderB;
        return (a.id || 0) - (b.id || 0);
    });

    return (
        <div className="admin-tab-content">
            <div className="admin-card">
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Homepage Hero Carousel Sliders ({sortedSliders.length})</h3>
                    <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('slider')}>
                        <i className="fa fa-plus m-r5" /> Add Hero Slide
                    </button>
                </div>
                <div className="card-body">
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                        {sortedSliders.map((s, index) => (
                            <div key={s.id || index} className="bg-white bdr-gray-light bdr-solid bdr-1" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.06)' }}>
                                <div style={{ height: '160px', position: 'relative', overflow: 'hidden', backgroundColor: '#1e293b', backgroundImage: `url("${getImageUrl(s.image || s.mainImage)}"), linear-gradient(135deg, #1e293b 0%, #0f172a 100%)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.45)' }} />
                                    <div style={{ position: 'absolute', bottom: '15px', left: '15px', right: '15px', color: '#ffffff', zIndex: 2 }}>
                                        <span className="admin-pill bg-orange m-b5" style={{ display: 'inline-block', fontSize: '11px' }}>{s.badge || s.tag || 'HERO SLIDE'}</span>
                                        <h4 style={{ margin: 0, color: '#ffffff', fontWeight: '700', fontSize: '16px' }}>{s.title}</h4>
                                    </div>
                                </div>
                                <div style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '13px', color: '#1e293b', fontWeight: '700', backgroundColor: '#f1f5f9', padding: '4px 10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                                        Order: #{s.order !== undefined && s.order !== null ? s.order : (index + 1)}
                                    </span>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <button className="admin-btn-icon btn-edit" onClick={() => onOpenModal('slider', s)} title="Edit Slide Order & Details">
                                            <i className="fa fa-pencil" />
                                        </button>
                                        <button className="admin-btn-icon btn-delete" onClick={() => onDeleteSlider(s.id)} title="Delete Slide">
                                            <i className="fa fa-trash" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlidersTab;
